module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-ties-remnants.ce71cb72.png";